import AppMode from '@/lib/constants/AppMode.enum';

const modesWithPlatformDifferences = [
  AppMode.PORTFOLIO,
  AppMode.COACH,
  AppMode.EDITOR,
];

export default modesWithPlatformDifferences;
